<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('central dispatch tracker services')"
      :columns="columns"
      :column_search="true"
      resource_url="/central-dispatch-tracker/service/datatables"
    >
      <template v-slot:buttons>
        <div
          class="button is-secondary"
          @click="download_all"
          :data-tooltip="`${$t('download all')}`"
        >
          <span class="icon"
            ><i class="fa fa-download has-text-primary"></i
          ></span>
        </div>
        <div
          class="button is-secondary"
          @click="delete_all"
          :data-tooltip="`${$t('delete all')}`"
        >
          <span class="icon"><i class="fa fa-trash has-text-danger"></i></span>
        </div>
        <div
          class="button is-secondary"
          @click="select_all"
          :data-tooltip="`${$t('select all')}`"
        >
          <span class="icon"><i class="fa fa-check has-text-warning"></i></span>
          <!-- <span>{{ $t("select all") }}</span> -->
        </div>
        <div
          class="button is-secondary"
          @click="deselect_all"
          :data-tooltip="`${$t('deselect all')}`"
        >
          <span class="icon"><i class="fa fa-check has-text-danger"></i></span>
          <!-- <span>{{ $t("deselect all") }}</span> -->
        </div>
        <button
          class="button is-secondary"
          @click="send_email"
          :disabled="selected_rows.length == 0"
          v-if="selected_rows.length"
          :data-tooltip="`${$t('send email')}`"
        >
          <span class="icon"><i class="fa fa-envelope has-text-info"></i></span>
          <!-- <span>{{ $t("send email") }}</span> -->
        </button>
        <button
          class="button is-secondary"
          @click="remove_selected"
          v-if="selected_rows.length"
          :data-tooltip="`${$t('delete')}`"
        >
          <span class="icon"> <i class="fa fa-trash has-text-danger"></i></span>
          <!-- <span>{{ $t("send email") }}</span> -->
        </button>
        <button
          class="button is-secondary"
          @click="assign_to_user"
          v-if="selected_rows.length"
          :data-tooltip="`${$t('assign to')}`"
        >
          <span class="icon"> <i class="fa fa-user has-text-warning"></i></span>
        </button>
        <button class="button is-secondary is-rounded" @click="update_online">
          <span class="icon"><i class="fa fa-plug"></i></span>
          <span>{{ $t("update") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <service-modal ref="service_modal" @success="refresh" />
  <update-modal ref="update_modal" @success="refresh" />
  <send-email-modal ref="send_email_modal" />
  <assign-modal ref="assign_modal" @success="refresh" />
  <shipper-services-modal ref="shipper_services_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  warning_message,
  del,
  post,
  get,
  error_message,
  success_message,
  download,
  format_currency,
} from "@/utils";
import ServiceModal from "./service_modal/Index.vue";
import UpdateModal from "./update_modal/Index.vue";
import SendEmailModal from "./send_email_modal/Index.vue";
import AssignModal from "./assign_modal/Index.vue";
import ShipperServicesModal from "./shipper_services_modal/Index.vue";
import moment from "moment";

export default {
  name: "DictamensDatatable",
  components: {
    GenericTable,
    ServiceModal,
    UpdateModal,
    SendEmailModal,
    AssignModal,
    ShipperServicesModal,
  },
  data() {
    let v = this;
    return {
      // columns: [
      //   {
      //     title: v.$t("select"),
      //     searchable: false,
      //     data: (row) => {
      //       return `<div class="field">
      //                 <input
      //                   class="is-checkradio service-checkbox"
      //                   id="chk_${row.uuid}"
      //                   type="checkbox"
      //                   onchange="change_selected({'central_dispatch_id': '${row.central_dispatch_id}','shipper_name': '${row.summary.shipper.name}', 'email': '${row.summary.shipper.email}'})"
      //                 />
      //                 <label for="chk_${row.uuid}"></label>
      //               </div>`;
      //     },
      //   },
      //   {
      //     title: v.$t("origin"),
      //     searchable: false,
      //     data: (row) => {
      //       return `<div class="title is-6">${row.summary.origin.city} - ${row.summary.origin.state}</div>
      //       <div class="subtitle is-6">${row.summary.origin.metro_area} (${row.summary.origin.zip})</div>`;
      //     },
      //   },
      //   {
      //     title: v.$t("destination"),
      //     searchable: false,
      //     data: (row) => {
      //       return `<div class="title is-6">${row.summary.destination.city} - ${row.summary.destination.state}</div>
      //       <div class="subtitle is-6">${row.summary.destination.metro_area} (${row.summary.destination.zip})</div>`;
      //     },
      //   },
      //   {
      //     title: v.$t("shipper"),
      //     searchable: false,
      //     data: (row) => {
      //       return `<div class="title is-6">${row.summary.shipper.name} (${row.summary.shipper.rating})</div>
      //       <div class="subtitle is-6">${row.summary.shipper.tier_group}</div>`;
      //     },
      //   },
      //   {
      //     title: v.$t("trip"),
      //     searchable: false,
      //     data: (row) => {
      //       let vehicles = row.summary.vehicles.map((v) => {
      //         return `<div class="title is-6">${v.quantity} x ${v.year} ${v.make} ${v.model} (${v.vehicle_type})</div>`;
      //       });
      //       return `<div class="title is-6">$ ${row.summary.price}</div>
      //       <div class="subtitle is-6">${v.$t("distance")} ${
      //         row.summary.distance
      //       }</div>
      //       <p>${vehicles.join("")}</p>`;
      //     },
      //   },
      //   // {
      //   //   title: v.$t("data"),
      //   //   name: "data",
      //   //   searchable: false,
      //   //   width: "80%",
      //   //   data: (row) => {
      //   //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
      //   //     // return row.name || "";
      //   //   },
      //   // },
      //   {
      //     title: v.$t("options"),
      //     width: "20%",
      //     searchable: false,
      //     data: (row) => {
      //       let btns = [
      //         {
      //           args: { uuid: row.uuid },
      //           tooltip: v.$t("delete"),
      //           icon: "fa fa-trash",
      //           icon_class: "is-small has-text-danger",
      //           click: (e) => {
      //             let uuid = e.detail.uuid;
      //             confirm_deletion_dialog(
      //               v.$t("are you sure to delete dictamen?"),
      //               v,
      //               () => {
      //                 del("/central-dispatch-tracker/service", { uuid: uuid })
      //                   .then(() => {
      //                     v.refresh();
      //                   })
      //                   .catch((error) => {
      //                     error_message(error);
      //                   });
      //               }
      //             );
      //           },
      //         },
      //         {
      //           args: { uuid: row.uuid },
      //           tooltip: v.$t("details"),
      //           icon: "fa fa-eye",
      //           icon_class: "is-small has-text-info",
      //           click: (e) => {
      //             v.$refs.service_modal.show(row.uuid);
      //           },
      //         },
      //       ];

      //       return generate_datatables_buttons(btns);
      //     },
      //   },
      // ],
      columns: [
        {
          title: v.$t("select"),
          searchable: false,
          data: (row) => {
            return `
        <div class="field has-text-centered">
          <input
            class="is-checkradio service-checkbox is-info"
            id="chk_${row.uuid}"
            type="checkbox"
            onchange="change_selected({'central_dispatch_id': '${row.central_dispatch_id}','shipper_name': '${row.summary.shipper.name}', 'email': '${row.summary.shipper.email}'})"
          />
          <label for="chk_${row.uuid}"></label>
        </div>`;
          },
        },
        {
          title: v.$t("origin"),
          searchable: false,
          data: (row) => {
            return `
        <div class="mb-1">
          <span class="has-text-weight-semibold">
            ${row.summary.origin.city} - ${row.summary.origin.state}
          </span>
        </div>
        <div class="is-size-7 has-text-grey">
          ${row.summary.origin.metro_area} (${row.summary.origin.zip})
        </div>`;
          },
        },
        {
          title: v.$t("destination"),
          searchable: false,
          data: (row) => {
            return `
        <div class="mb-1">
          <span class="has-text-weight-semibold">
            ${row.summary.destination.city} - ${row.summary.destination.state}
          </span>
        </div>
        <div class="is-size-7 has-text-grey">
          ${row.summary.destination.metro_area} (${row.summary.destination.zip})
        </div>`;
          },
        },
        {
          title: v.$t("shipper"),
          searchable: false,
          data: (row) => {
            return `
        <div class="mb-1">
          <a onclick="show_shipper_details('${row.summary.shipper.customerId}','${row.summary.shipper.name}')" class="tag is-info is-dark">${row.summary.shipper.name}</a>
          <span class="tag is-warning is-dark ml-1">★ ${row.summary.shipper.rating}</span>
        </div>
        <div class="is-size-7 has-text-grey">
          ${row.summary.shipper.tier_group}
        </div>`;
          },
        },
        {
          title: v.$t("trip"),
          searchable: false,
          data: (row) => {
            let vehicles = row.summary.vehicles.map((v) => {
              return `
          <li class="is-size-7">
            ${v.quantity} × ${v.year} ${v.make} ${v.model}
            <span class="tag is-dark ml-1">${v.vehicle_type}</span>
          </li>`;
            });

            return `
        <div class="mb-1 has-text-weight-bold has-text-success">
          $ ${row.summary.price}
        </div>
        <div class="is-size-7 has-text-grey mb-1">
          ${v.$t("distance")} ${row.summary.distance}
        </div>
        <ul class="pl-3">${vehicles.join("")}</ul>`;
          },
        },
        {
          title: v.$t("options"),
          width: "15%",
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  v.$refs.service_modal.show(row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete service?"),
                    v,
                    () => {
                      del("/central-dispatch-tracker/service", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            if (!row.is_contacted) {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("mark as contacted"),
                icon: "fa fa-check",
                icon_class: "is-small has-text-success",
                click: (e) => {
                  post("/central-dispatch-tracker/service/contacted", {
                    uuid: row.uuid,
                  })
                    .then(() => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            } else {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("already contacted"),
                icon: "fa fa-check",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  del("/central-dispatch-tracker/service/contacted", {
                    uuid: row.uuid,
                  })
                    .then(() => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],

      selected_rows: [],
    };
  },
  methods: {
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    update_online() {
      let v = this;
      v.$refs.update_modal.show();
    },
    select_all() {
      let v = this;
      let checkboxes = window.jQuery(".dt-container .service-checkbox");
      checkboxes.map((i, checkbox) => {
        let is_selected = window.jQuery(checkbox).is(":checked");
        if (!is_selected) window.jQuery(checkbox).click();
      });
    },
    deselect_all() {
      let v = this;
      let checkboxes = window.jQuery(".dt-container .service-checkbox");
      checkboxes.map((i, checkbox) => {
        let is_selected = window.jQuery(checkbox).is(":checked");
        if (is_selected) window.jQuery(checkbox).click();
      });
    },
    send_email() {
      let v = this;
      v.$refs.send_email_modal.show(v.selected_rows);
    },
    remove_selected() {
      let v = this;
      let central_dispatch_ids = v.selected_rows.map(
        (x) => x.central_dispatch_id
      );
      confirm_deletion_dialog(
        v.$t("are you sure to delete selected services?"),
        v,
        () => {
          post("/central-dispatch-tracker/service/bulk", {
            central_dispatch_ids: central_dispatch_ids,
          })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    assign_to_user() {
      let v = this;
      v.$refs.assign_modal.show(v.selected_rows);
    },
    download_all() {
      let v = this;
      download(
        "/central-dispatch-tracker/service/download-bulk",
        "service-list.csv"
      )
        .then((data) => {
          success_message(v.$t("download started"));
        })
        .catch((error) => {
          error_message(error);
        });
    },
    delete_all() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete all services?"),
        v,
        () => {
          del("/central-dispatch-tracker/service/bulk", {})
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {
    let v = this;
    v.refresh();

    window.change_selected = (obj) => {
      // console.log(obj);
      let index = v.selected_rows.findIndex(
        (x) => x.central_dispatch_id == obj.central_dispatch_id
      );
      if (index > -1) v.selected_rows.splice(index, 1);
      else v.selected_rows.push(obj);
    };
  },
  created() {
    let v = this;
    window.show_shipper_details = function (shipper_id, shipper_name) {
      v.$refs.shipper_services_modal.open({ shipper_id, shipper_name });
    };
  },
  beforeUnmount() {
    delete window.show_shipper_details;
  },
};
</script>

<style></style>
